import { FormattedMessage } from 'react-intl';
import type { ColumnType } from 'antd/lib/table';

export const columns: ColumnType<cyrian.api.farms.Farm>[] = [
  {
    title: <FormattedMessage id="farms.farmId" />,
    dataIndex: 'farmId',
    key: 'farmId',
    sorter: true,
    width: 140,
    render: (_: any, record: cyrian.api.farms.Farm) => record.farmId?.trim() || '—',
  },
  {
    title: <FormattedMessage id="farmers.farmerId" />,
    key: 'farmerId',
    sorter: true,
    width: 100,
    render: (_: any, record: cyrian.api.farms.Farm) => record.farmer?.farmerId ?? '—',
  },
  {
    title: <FormattedMessage id="farms.product" />,
    dataIndex: 'product',
    key: 'product',
    sorter: true,
    width: 120,
  },
  {
    title: <FormattedMessage id="farms.village" />,
    dataIndex: 'village',
    key: 'village',
    sorter: true,
    width: 120,
  },
  {
    title: <FormattedMessage id="farms.district" />,
    dataIndex: 'district',
    key: 'district',
    width: 120,
  },
  {
    title: <FormattedMessage id="farms.region" />,
    dataIndex: 'region',
    key: 'region',
    width: 120,
  },
  {
    title: <FormattedMessage id="farms.plotsCount" />,
    dataIndex: 'plotsCount',
    key: 'plotsCount',
    sorter: true,
    width: 100,
  },
];
